import React, { useEffect } from 'react';
import './Dialog.css';

export default function Dialog({ open, onClose, title, children }) {
  useEffect(() => {
    const onEsc = (e) => e.key === 'Escape' && onClose?.();
    if (open) document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="dlg-overlay" onMouseDown={onClose}>
      <div className="dlg-content" onMouseDown={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={title}>
        {title && <h2 className="dlg-title">{title}</h2>}
        <div className="dlg-body">{children}</div>
        <button className="dlg-close" onClick={onClose}>×</button>
      </div>
    </div>
  );
}
